import React, { memo, useContext, useState } from 'react';
import { ModalContext } from '../../context';
import Customer from './Customer';
import DeliveryDate from './DeliveryDate';
import DeliveryType from './DeliveryType';
import Address from './Address';
import { TabTitle } from '@/components/ShipmentForm/blocks';

/**
 * Customer section of the Edit Order modal: contact, delivery date, address, and delivery type.
 * Will-call orders skip the date and address. Takes no props; reads `ModalContext`.
 */
const CustomerTab = memo(() => {
    const { state: modalState, callbacks } = useContext(ModalContext);
    const { isDirty, order, hasError, options } = modalState;
    const [collapsed, setCollapsed] = useState(false);
    const isWillCall = order.order_type === 'will_call';

    return (
        <>
            <TabTitle collapsed={collapsed} callbacks={{ setCollapsed }}>
                Customer
            </TabTitle>
            {collapsed ? null : (
                <>
                    <Customer
                        isDirty={isDirty}
                        order={order}
                        hasError={hasError}
                        callbacks={callbacks}
                        options={options}
                        modalState={modalState}
                    />
                    {/* Will call has no delivery leg, so no date and no address. It still needs a
                        service level: pricing selects base-rate rows off dropoff_location_type, and
                        the will-call fee can be configured as a percentage of the freight charge. */}
                    {!isWillCall && (
                        <>
                            <DeliveryDate
                                isDirty={isDirty}
                                order={order}
                                hasError={hasError}
                                callbacks={callbacks}
                                options={options}
                            />
                            <Address
                                isDirty={isDirty}
                                order={order}
                                hasError={hasError}
                                callbacks={callbacks}
                                options={options}
                            />
                        </>
                    )}
                    <DeliveryType
                        isDirty={isDirty}
                        order={order}
                        hasError={hasError}
                        callbacks={callbacks}
                        options={options}
                    />
                </>
            )}
        </>
    );
});

export default CustomerTab;
